import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { profileDetails } from "../../services/ProfileService";

/* ================= THUNK ================= */

export const fetchProfileDetails = createAsyncThunk(
  "profileDetails/fetch",
  async (params = {}, { rejectWithValue }) => {
    try {
      const res = await profileDetails(params);

      if (res?.status === 200 && res?.data) {
        return res.data;
      }

      return rejectWithValue(res?.message || "Failed to fetch profile");
    } catch (err) {
      return rejectWithValue(err?.message || "Something went wrong");
    }
  },
);

/* ================= INITIAL STATE ================= */

const initialState = {
  data: null,
  loading: false,
  error: null,
};

/* ================= SLICE ================= */

const profileDetailsSlice = createSlice({
  name: "profileDetails",
  initialState,
  reducers: {
    clearProfileDetails: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfileDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProfileDetails.fulfilled, (state, action) => {
        state.loading = false;

        const d = action.payload || {};

        /* ================= SAFE NORMALIZATION ================= */

        state.data = {
          _id: d?._id || null,
          firstName: d?.firstName || "",
          lastName: d?.lastName || "",
          email: d?.email || "",
          bio: d?.bio || "",

          image: d?.image?.url || null,
          coverMedia: d?.coverMedia?.url || null,

          /* ===== ORGANIZATION ===== */
          organization: {
            id: d?.organization?._id || null,
            slug: d?.organization?.slug || null,

            name: d?.organization?.content?.en?.title || "No Organization",

            description: d?.organization?.content?.en?.content || "",

            logo: d?.organization?.logo?.url?.url || null,

            website: d?.organization?.socialLinks?.website || null,

            /* ===== ADDRESS ===== */
            address: (() => {
              const addr = d?.organization?.address?.[0];
              if (!addr) return null;

              return {
                city: addr?.city || "",
                state: addr?.state || "",
                country: addr?.country || "",
                full:
                  [addr?.city, addr?.state, addr?.country]
                    .filter(Boolean)
                    .join(", ") || null,
              };
            })(),
          },
        };
      })
      .addCase(fetchProfileDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error fetching profile";
      });
  },
});

export const { clearProfileDetails } = profileDetailsSlice.actions;
export default profileDetailsSlice.reducer;
